import { render, staticRenderFns } from "./Paiement.vue?vue&type=template&id=25a3d9a4&"
import script from "./Paiement.vue?vue&type=script&lang=js&"
export * from "./Paiement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports